import axios from "axios";
import { APIURL } from "./config";
import { toast } from "react-toastify";
import {
  Staff_LIST,
  Staff_ADD,
  Staff_UPDATE,
  STAFF_DELETE,
  LOADING,
  NOT_FOUND,
} from "./type";

export const staffList = () => async (dispatch) => {
  dispatch({
    type: LOADING,
    payload: "",
  });
  const token = localStorage.getItem("token");
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  fetch(`${APIURL}/api/v1/users/filter?position=user_staff`, requestOptions)
    .then((response) => response.json())
    .then((result) => {
      const staff = result?.data?.filteredUser?.filter(
        (item) => item?.isDeleted !== true
      );
      dispatch({
        type: Staff_LIST,
        payload: staff,
      });
      if (staff?.length === 0) {
        dispatch({
          type: NOT_FOUND,
          payload: "",
        });
      }
    })
    .catch((error) => {
      toast.error(error?.response?.data?.message);
    });
};

export const addStaff = (val) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const body = JSON.stringify({
    employee_id: val.employee_id,
    firstName: val.firstName,
    middleName: val.middleName,
    lastName: val.lastName,
    phone: val.mobile,
    email: val.email,
    sendEmail: true,
    designation: val.designation,
    experience: val.experience,
    lic_no: val.lic_no,
    status: val?.status,
    image: val.image == "undefined" ? "" : val.image,
    position: "user_staff",
  });
  try {
    const response = await axios.post(`${APIURL}/api/v1/users`, body, config);
    dispatch({ type: Staff_ADD, payload: response?.data });
    toast.success("Staff Created Successfully!");
    setTimeout(() => {
      return (window.location.href = "/manage-staff");
    }, 1000);
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const updateStaff = (val, id) => async (dispatch) => {
  dispatch({
    type: LOADING,
    payload: "",
  });
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  var body = JSON.stringify({
    employee_id: val.employee_id,
    firstName: val.firstName,
    middleName: val?.middleName,
    lastName: val?.lastName,
    phone: val.mobile,
    email: val.email,
    sendEmail: true,
    designation: val.designation,
    experience: val.experience,
    lic_no: val.lic_no,
    status: val?.status,
    image: val.image == "undefined" ? "" : val.image,
    position: "user_staff",
  });
  try {
    const response = await axios.patch(
      `${APIURL}/api/v1/users/${id}`,
      body,
      config
    );
    dispatch({ type: Staff_UPDATE, payload: response?.data });
    toast.success("Staff Updated Successfully!");
    setTimeout(() => {
      return (window.location.href = "/manage-staff");
    }, 1000);
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const staffsDelete = (id) => async (dispatch) => {
  dispatch({
    type: LOADING,
    payload: "",
  });
  const token = localStorage.getItem("token");
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    isDeleted: true,
  });

  var requestOptions = {
    method: "PATCH",
    headers: myHeaders,
    body: raw,
    redirect: "manual",
  };

  if (window.confirm("Do you want to delete this staff member?")) {
    try {
      const res = await fetch(`${APIURL}/api/v1/users/deleteUsers/${id}`, requestOptions)
      const response = await res.json()
      if (response?.status == "success") {
        toast.success("Staff Deleted Successfully!");
        return { success: true }
      }
    } catch (error) {
      console.log('error', error)
    }
    const res = await fetch(`${APIURL}/api/v1/users/deleteUsers/${id}`, requestOptions)
    const response = await res.json()
    if (response?.status == "success") {
      toast.success("Staff Deleted Successfully!");
      return { success: true }
    }


  }
};

export const updateStaffStatus = (id, oldStaffId) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  var body = JSON.stringify({
    status: "busy",
  });
  try {
    const response = await axios.patch(
      `${APIURL}/api/v1/users/${id}`,
      body,
      config
    );
    console.log(response, "responseresponse");
    if (response.data.status == "success" && oldStaffId !== undefined) {
      dispatch(enableStaffStatus(oldStaffId));
    }
    dispatch({ type: Staff_UPDATE, payload: response?.data });
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const enableStaffStatus = (id) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  var body = JSON.stringify({
    status: "available",
  });
  try {
    const response = await axios.patch(
      `${APIURL}/api/v1/users/${id}`,
      body,
      config
    );
    dispatch({ type: Staff_UPDATE, payload: response?.data });
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const multiStaffDelete = (id) => {
  const token = localStorage.getItem("token");
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    isDeleted: true,
  });

  var requestOptions = {
    method: "PATCH",
    headers: myHeaders,
    body: raw,
    redirect: "manual",
  };

  if (window.confirm("Do you want to delete the selected staff?")) {
    fetch(`${APIURL}/api/v1/users/multiUser/${id}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result?.status == "success") {
          toast.success("Staff Deleted Successfully!");
        }
      })
      .catch((error) => console.log("error", error));
  }
};
